<template>
  <div class="panel-wrapper" id="panel-wrapper" v-if="adminBarData">
    <div
      class="panel-links"
      v-for="(data, index) in adminBarData.items"
      :key="index"
    >
      <a :title="data.label" :href="data.link" target="_blank">{{
        data.label
      }}</a>
    </div>
    <div class="login-info">
      <a
        :title="adminBarData.account"
        :href="adminBarData.account_link"
        target="_blank"
        >{{ adminBarData.account }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminPanelBar",
  props: ["adminBarData"],
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.panel {
  &-wrapper {
    display: none;
    justify-content: space-between;
    padding: 0 0.75rem;
    background-color: #000;
    position: sticky;
    top: 0;
    z-index: 1000;

    .login-info {
      padding: 0px 7px;
      a {
        font-size: 12px;
        color: @white !important;
      }
      &:hover {
        background-color: @lightdark;
        a {
          color: #00ffff !important;
        }
      }
    }

    @media (min-width: @sizes[medium]) {
      display: flex;
    }
  }
  &-links {
    padding: 0px 7px;
    a {
      font-size: 12px;
      color: @white !important;
    }
    &:hover {
      background-color: @lightdark;
      a {
        color: #00ffff !important;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/AdminPanelBar.vue